import { posthog } from './posthog';

export function trackEvent(eventName, properties) {
    if (typeof window === 'undefined') return;
    if (typeof posthog.capture !== 'function') return;

    posthog.capture(eventName, properties);
}
